import { render, staticRenderFns } from "./projectProgress.vue?vue&type=template&id=0ddd3d16"
import script from "./projectProgress.vue?vue&type=script&lang=js"
export * from "./projectProgress.vue?vue&type=script&lang=js"
import style0 from "./projectProgress.vue?vue&type=style&index=0&id=0ddd3d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports